import Callout from "@/components/articles/Callout";
import FAQ from "@/components/articles/FAQ";
import CTA from "@/components/articles/CTA";
import MDXImage from "@/components/articles/MDXImage";
import MDXLink from "@/components/articles/MDXLink";
import Quiz from "@/components/articles/Quiz";
import type { MDXComponents } from "mdx/types";

export function useMDXComponents(
  components: MDXComponents = {},
): MDXComponents {
  return {
    Callout,
    FAQ,
    CTA,
    Image: MDXImage,
    img: MDXImage,
    a: MDXLink,
    Quiz,
    ...components,
  };
}
